import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6171aca2d1ce4da1690eae35a1eef565.jpg"
          alt="Ingeniería Eléctrica"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/71fb4f6d-05d4-40e7-b3f8-9fa0dff80283.png" 
                alt="JDJ Ingeniería & Arquitectura" 
                className="h-12 w-auto"
              />
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <a href="#about" className={`text-sm font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-400'}`}>Nosotros</a>
              <a href="#services" className={`text-sm font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-400'}`}>Servicios</a>
              <a href="#projects" className={`text-sm font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-400'}`}>Proyectos</a>
              <a href="#contact" className={`text-sm font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-400'}`}>Contacto</a>
              <button 
                onClick={scrollToContact}
                className="bg-blue-600 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors whitespace-nowrap"
              >
                Solicitar Cotización
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center w-full">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Ingeniería y Arquitectura para<br />proyectos que exigen <span className="text-blue-400">precisión</span>
        </h1>
        <p className="text-xl md:text-2xl text-gray-200 mb-10 max-w-4xl mx-auto leading-relaxed">
          Diseño, desarrollo e implementación de soluciones eléctricas, arquitectónicas e industriales en Lima y todo el Perú
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button 
            onClick={scrollToContact}
            className="bg-blue-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-blue-700 transition-all hover:scale-105 whitespace-nowrap w-full sm:w-auto"
          >
            Solicitar Cotización
          </button>
          <button 
            onClick={scrollToContact}
            className="bg-white text-gray-900 px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-100 transition-all hover:scale-105 whitespace-nowrap w-full sm:w-auto"
          >
            Contactar Ingeniero
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </div>
      </div>
    </div>
  );
}